<template>
  <div class="app-container course-courseware-detail">
    <el-button
      icon="el-icon-arrow-left"
      @click="goBack"
      class="back-button"
      type="text">
    </el-button>
    <basic-container>
      <el-tabs v-if="detail && detail.type !== undefined" v-model="activeName" @tab-click="onTabShow">
        <el-tab-pane label="基本资料" name="courseCoursewareDetail">
          <div class="operation">
            <el-button size="small" type="primary" @click="handleEditCourseCourseware">编辑课时</el-button>
          </div>
          <el-row class="course-courseware-detail-item">
            <el-col :span="3">课时类型:</el-col>
            <el-col :span="16">{{ getType(detail.type) }}</el-col>
          </el-row>
          <el-row class="course-courseware-detail-item">
            <el-col :span="3">课时名称:</el-col>
            <el-col :span="16">{{ detail.courseCoursewareName }}</el-col>
          </el-row>
          <el-row class="course-courseware-detail-item">
            <el-col :span="3">课时名称（英文）:</el-col>
            <el-col :span="16">{{ detail.courseCoursewareNameEn }}</el-col>
          </el-row>
          <el-row class="course-courseware-detail-item">
            <el-col :span="3">课时介绍:</el-col>
            <el-col :span="16">
              <span v-if="!detail.courseCoursewareDescription"
              >
                --
              </span>
              <div class="course-courseware-detail-description" v-else v-html="detail.courseCoursewareDescription"></div>
            </el-col>
          </el-row>
          <el-row class="course-courseware-detail-item">
            <el-col :span="3">课时介绍（英文）:</el-col>
            <el-col :span="16">
              <span v-if="!detail.courseCoursewareDescriptionEn"
              >
                --
              </span>
              <div class="course-courseware-detail-description" v-else v-html="detail.courseCoursewareDescriptionEn"></div>
            </el-col>
          </el-row>
          <el-row class="course-courseware-detail-item">
            <el-col :span="3">课时开始时间:</el-col>
            <el-col :span="16">{{ detail.courseCoursewareStartTime ? detail.courseCoursewareStartTime : "--"  }}</el-col>
          </el-row>
          <el-row class="course-courseware-detail-item">
            <el-col :span="3">课时积分:</el-col>
            <el-col :span="16">{{ detail.courseCoursewareRewardValue }}</el-col>
          </el-row>
          <el-row v-if="detail.type != coursewareSelectEnums.COMMENT.code" class="course-courseware-detail-item">
            <el-col :span="3">开启评论区:</el-col>
            <el-col :span="16">{{ detail.courseCoursewareCommentActive ? "是" : "否" }}</el-col>
          </el-row>
          <template v-if="detail.type == coursewareSelectEnums.COMMENT.code">
            <el-row class="course-courseware-detail-item">
              <el-col :span="3">发言形式:</el-col>
              <el-col :span="16">{{ getCommentType(detail.courseCoursewareCommentType) }}</el-col>
            </el-row>
            <el-row class="course-courseware-detail-item">
              <el-col :span="3">发言次数限制:</el-col>
              <el-col :span="16">{{ getCommentLimitCount(detail.courseCoursewareCommentLimitCount) }}</el-col>
            </el-row>
          </template>
          <template v-if="detail.type == coursewareSelectEnums.PDF.code || detail.type == coursewareSelectEnums.VIDEO.code">
            <el-row class="course-courseware-detail-item">
              <el-col :span="3">中文课件名称:</el-col>
              <el-col :span="16">
                <a class="courseware-name" @click="handleView(detail.coursewareId)">{{ detail.coursewareName }}</a>
              </el-col>
            </el-row>
            <el-row class="course-courseware-detail-item">
              <el-col :span="3">中文课件文件:</el-col>
              <el-col :span="16">
                <a class="courseware-url" v-if="COURSEWARE_FILE_TYPE_ENUM.PDF.value === detail.type" :href="detail.coursewareUrl" target="_blank">PDF文件</a>
                <div class="course-courseware-content-video" v-if="COURSEWARE_FILE_TYPE_ENUM.VIDEO.value === detail.type">
                  <img :src="detail.coverUrl" @click="viewVideo(detail.coursewareUrl)">
                  <i class="icon-content-play"></i>
                </div>
              </el-col>
            </el-row>
            <el-row class="course-courseware-detail-item">
              <el-col :span="3">英文课件名称:</el-col>
              <el-col :span="16">
                <a class="courseware-name" @click="handleView(detail.coursewareId)">{{ detail.coursewareNameEn }}</a>
              </el-col>
            </el-row>
            <el-row class="course-courseware-detail-item">
              <el-col :span="3">英文课件文件:</el-col>
              <el-col :span="16">
                <a class="courseware-url" v-if="COURSEWARE_FILE_TYPE_ENUM.PDF.value === detail.type" :href="detail.coursewareUrlEn" target="_blank">PDF文件</a>
                <div class="course-courseware-content-video" v-if="COURSEWARE_FILE_TYPE_ENUM.VIDEO.value === detail.type">
                  <img :src="detail.coverUrlEn" @click="viewVideo(detail.coursewareUrlEn)">
                  <i class="icon-content-play"></i>
                </div>
              </el-col>
            </el-row>
          </template>
          <el-row class="course-courseware-detail-item">
            <el-col :span="3">创建人:</el-col>
            <el-col :span="16">{{ detail.courseCoursewareCreator }}</el-col>
          </el-row>
          <el-row class="course-courseware-detail-item">
            <el-col :span="3">创建时间:</el-col>
            <el-col :span="16">{{ detail.courseCoursewareInsertedTime }}</el-col>
          </el-row>
        </el-tab-pane>
        <el-tab-pane label="学习进度" name="learningProcess">
          <div class="course-learning-process-list">
            <div class="course-learning-process-list-filter">
              <el-row>
                <el-col :span="6">
                  <div class="grid-content bg-purple">
                    <el-input class="course-learning-process-list-filter-value" v-model.trim="search.unionId" @keyup.enter.native="searchChange" placeholder="员工号" clearable size="small" ></el-input>
                  </div>
                </el-col>
                <el-col :span="6">
                  <div class="grid-content bg-purple">
                    <el-input class="course-learning-process-list-filter-value" v-model.trim="search.searchValue" @keyup.enter.native="searchChange" placeholder="Birth Name或Full Name" clearable size="small" ></el-input>
                  </div>
                </el-col>
                <el-col :span="6">
                  <div class="grid-content bg-purple">
                    <el-input class="course-learning-process-list-filter-value" v-model.trim="search.organizationalUnitName" @keyup.enter.native="searchChange" placeholder="Organizational Unit Name" clearable size="small" ></el-input>
                  </div>
                </el-col>
                <el-col :span="6">
                  <div class="grid-content bg-purple">
                    <el-select 
                      class="course-learning-process-list-filter-value" 
                      ref="statusSelect" 
                      v-model="search.learningStatus" 
                      @change="searchChange" 
                      @keydown.enter.native="$refs.statusSelect.visible = false" 
                      placeholder="课时学习状态" 
                      clearable 
                      size="small">
                      <el-option
                        v-for="(item, index) in learningStatusOptions"
                        :key="index"
                        :label="item.label"
                        :value="item.value">
                      </el-option>
                    </el-select>
                  </div>
                </el-col>
                <el-col :span="24">
                  <div>
                    <el-button class="course-learning-process-list-filter-reset" size="small" @click="searchChange">立即筛选</el-button>
                    <el-button class="course-learning-process-list-filter-search" size="small" @click="searchReset">清除条件</el-button>
                  </div>
                </el-col>
              </el-row>
            </div>
          </div>
          <avue-crud ref="crud"
            :option="memberLearningProcessListTableOption"
            :data="learningProcessTableData"
            :page="page"
            :table-loading="tableLoading"
            @size-change="sizeChange"
            @current-change="currentChange"
            @sort-change="sortChange"
            @search-change="searchChange">
            <template slot="empty">
              暂无数据
            </template>
            <template slot="menuLeft">
              <el-button type="primary" icon="el-icon-download" size="small" @click="handleLearningProcessExport" :loading="learningProcessExportLoading">{{learningProcessExportName}}</el-button>
            </template>

            <template slot-scope="scope" slot="phoneNumber">
              <sensitive-data type="phoneNumber" :rawData="scope.row.phoneNumber" :unionId="scope.row.unionId" />
            </template>

            <template slot-scope="scope" slot="learningProcess">
              {{ 
                scope.row.learningStatus == learningStatusEnum.FINISHED.code
                ? '100%' : scope.row.coursewareLength == null || scope.row.coursewareLength === 0
                ? `${scope.row.learningProcess}%` : `${Math.floor((scope.row.learningProcess * 100) / scope.row.coursewareLength)}%`
              }}
            </template>
          </avue-crud>
        </el-tab-pane>
        <el-tab-pane label="收藏列表" name="courseCoursewarefavorite">
          <el-table :data="courseCoursewareFavoriteData" stripe
            style="width:90%" tooltip-effect="dark">
            <el-table-column align="center" prop="favoriteTime" label="收藏时间" width="200"></el-table-column>
            <el-table-column align="center" prop="favoriteBy" label="收藏用户Full Name"></el-table-column>
            <el-table-column align="center" prop="favoriteByRealname" label="收藏用户Birth Name"></el-table-column>
          </el-table>
          <el-pagination :page-size="courseCoursewareFavoritePage.pageSize"
                         :page-sizes="courseCoursewareFavoritePage.pageSizes"
                         :current-page="courseCoursewareFavoritePage.currentPage"
                         :total="courseCoursewareFavoritePage.total"
                         :layout="courseCoursewareFavoritePage.layout"
                         @current-change="courseCoursewareFavoriteCurrentChange"
                         @size-change="courseCoursewareFavoriteSizeChange">
          </el-pagination>
        </el-tab-pane>
        <el-tab-pane v-if="detail.type != coursewareSelectEnums.COMMENT.code" label="评论列表" name="courseCoursewareComment">
          <el-table :data="courseCoursewareCommentData" stripe tooltip-effect="dark">
            <el-table-column prop="content" label="评论内容" show-overflow-tooltip></el-table-column>
            <el-table-column align="center" prop="commentByName" label="评论人Full Name" width="140"></el-table-column>
            <el-table-column align="center" prop="commentByRealname" label="评论人Birth Name" width="140"></el-table-column>
            <el-table-column align="center" prop="commentTime" label="评论时间" width="200"></el-table-column>
            <el-table-column align="center" prop="commentToName" label="回复对象Full Name" width="160"></el-table-column>
            <el-table-column align="center" prop="commentToRealname" label="回复对象Birth Name" width="160"></el-table-column>
            <el-table-column align="center" label="是否已下架" width="100">
              <template slot-scope="scope">
                {{scope.row.isBanned ? "是" : "否"}}
              </template>
            </el-table-column>
            <el-table-column align="center" label="下架原因"  width="200" show-overflow-tooltip>
              <template slot-scope="scope">
                {{scope.row.banComment || "--"}}
              </template>
            </el-table-column>
            <el-table-column align="center" label="操作" width="150">
              <template slot-scope="scope">
                <el-button size="mini"
                  type="text"
                  icon="el-icon-upload2"
                  title="上架"
                  v-if="scope.row.isBanned"
                  @click="handleUp(scope.row,scope.index)">上架
                </el-button>
                <el-button size="mini"
                      type="text"
                      icon="el-icon-download"
                      title="下架"
                      v-if="!scope.row.isBanned"
                      @click="handleDown(scope.row,scope.index)">下架
                </el-button>
              </template>
            </el-table-column>
          </el-table>
          <el-pagination :page-size="courseCoursewareCommentPage.pageSize"
                         :page-sizes="courseCoursewareCommentPage.pageSizes"
                         :current-page="courseCoursewareCommentPage.currentPage"
                         :total="courseCoursewareCommentPage.total"
                         :layout="courseCoursewareCommentPage.layout"
                         @current-change="courseCoursewareCommentCurrentChange"
                         @size-change="courseCoursewareCommentSizeChange">
          </el-pagination>
        </el-tab-pane>
        <el-tab-pane v-if="detail.type == coursewareSelectEnums.COMMENT.code" label="留言列表" name="courseCoursewarePost">
          <div class="courseware-post-list-filter">
            <el-row>
              <el-col :span="6">
                <div class="grid-content bg-purple">
                  <el-input class="courseware-post-list-filter-value" v-model.trim="coursewarePostSearch.keywords" @keyup.enter.native="coursewarePostSearchChange" placeholder="内容标题/内容正文" clearable size="small" suffix-icon="el-icon-search"></el-input>
                </div>
              </el-col>
              <el-col :span="6">
                <div class="grid-content bg-purple">
                  <el-input class="courseware-post-list-filter-value" v-model.trim="coursewarePostSearch.postedByName" @keyup.enter.native="coursewarePostSearchChange" placeholder="官方号名称或发布者姓名" clearable size="small" suffix-icon="el-icon-search"></el-input>
                </div>
              </el-col>
              <el-col :span="6">
                <div class="grid-content bg-purple">
                  <el-date-picker
                    class="courseware-post-list-filter-date"
                    v-model="coursewarePostSearch.searchTime"
                    type="daterange"
                    value-format="yyyy-MM-dd"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    size="small">
                  </el-date-picker>
                </div>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="6">
                <div class="grid-content bg-purple">
                  <el-select class="courseware-post-list-filter-value" placeholder="是否已下架" v-model="coursewarePostSearch.isBanned" clearable size="small">
                    <el-option
                      v-for="item in bannedCoursewarePostOptions"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                    </el-option>
                  </el-select>
                </div>
              </el-col>
              <el-col :span="6">
                <div class="grid-content bg-purple">
                  <el-input class="courseware-post-list-filter-value" v-model.trim="coursewarePostSearch.banComment" @keyup.enter.native="coursewarePostSearchChange"
                  placeholder="下架原因" clearable size="small" suffix-icon="el-icon-search"></el-input>
                </div>
              </el-col>
              <el-col :span="6">
                <div>
                  <el-button class="courseware-post-list-filter-reset" size="small" @click="coursewarePostSearchChange">立即筛选</el-button>
                  <el-button class="courseware-post-list-filter-search" size="small" @click="coursewarePostSearchReset">清除条件</el-button>
                </div>
              </el-col>
            </el-row>
          </div>
          <avue-crud ref="crud"
                    :option="coursewarePostTableOption"
                    :data="coursewarePostTableData"
                    :page="coursewarePostPage"
                    :table-loading="coursewarePostTableLoading"
                    :before-open="handleCoursewarePostOpenBefore"
                    @current-change="handleCoursewarePostCurrentChange"
                    @size-change="handleCoursewarePostSizeChange"
                    @sort-change="handleCoursewarePostSortChange">
            <template slot="empty">
              暂无数据
            </template>
            <template slot="title" slot-scope="scope">
              <div class="title">
                <div class="courseware-post-cover-image" v-if="scope.row.attachments[0]" v-viewer>
                  <img :src="scope.row.attachments[0].attachmentUrl" :class="{'hide-redundant-comment-images': index > 0 }">
                </div>
                <a href="javascript:void(0);" @click="handleCoursewarePostView(scope.row, scope.index);"
                    class="courseware-post-list-container-button">
                  {{scope.row.title ? scope.row.title : scope.row.titleEn}}
                </a>
              </div>
            </template>
            <template slot="menu" slot-scope="scope" width=100>
              <el-button size="mini"
                    type="text"
                    icon="el-icon-upload2"
                    title="上架"
                    v-if="scope.row.isBanned"
                    @click="handleCoursewarePostUp(scope.row, scope.index)">上架
              </el-button>
              <el-button size="mini"
                    type="text"
                    icon="el-icon-download"
                    title="下架"
                    v-if="!scope.row.isBanned"
                    @click="handleCoursewarePostDown(scope.row, scope.index)">下架
              </el-button>
            </template>
          </avue-crud>
        </el-tab-pane>
        <el-dialog
          title="下架"
          :visible.sync="banDialogVisible"
          width="30%">
          <template>
            <div>
              <el-label class="down-dialog-item-label">下架原因</el-label>
              <el-input v-model="banDialogComment"></el-input>
            </div>
          </template>
          <span slot="footer" class="dialog-footer">
            <el-button @click="banDialogVisible = false">取 消</el-button>
            
            <el-button v-if="detail.type == coursewareSelectEnums.COMMENT.code" type="primary" @click="handleCoursewarePostDownSubmit()">确 定</el-button>
            <el-button v-else type="primary" @click="handleDownSubmit()">确 定</el-button>
          </span>
        </el-dialog>
        <courseware-dialog
          :courseware-dialog-visible="coursewareDialogVisible"
          :is-edit-courseware="true"
          :courseware-form="coursewareForm"
          :current-selected-mode-code="detail.type"
          @close="closeCoursewareDialog()" 
        />
      </el-tabs>
    </basic-container>
  </div>
</template>
<script>
import { exporting } from '@/util/exportUtil';
import SensitiveData from '@/components/sensitive-data';
import { fetchDepartmentOptions } from '@/api/admin/dept';
import { getCourseCoursewareById, exportLearningProcess, fetchLearningProcessList, updateCommentStatus, fetchCoursewarePostList, updateCoursewarePostBanStatus } from '@/api/app/course';
import { coursewareFileTypeEnums as COURSEWARE_FILE_TYPE_ENUM, coursewareSelectEnums, memberLearningProcessListTableOption,
  coursewareCommentLimitCountOptions, coursewareCommentTypeOptions, learningStatusOptions, learningStatusEnum, coursewarePostTableOption
 } from '@/const/crud/app/course';
 import { formatTime } from '../courseware/util/index';
 import courseCoursewareFavoriteList  from '@/mixins/course/favorite-list';
 import courseCoursewareCommentList  from '@/mixins/course/comment-list';
 import CoursewareDialog from "../course/components/CoursewareDialog.vue";

export default {
  mixins: [courseCoursewareFavoriteList, courseCoursewareCommentList],
  components: {
    SensitiveData,
    CoursewareDialog,
  },
  data() {
    return {
      id: 0,
      activeName: 'courseCoursewareDetail',
      COURSEWARE_FILE_TYPE_ENUM,
      detail: {},
      coursewareSelectEnums: coursewareSelectEnums,
      coursewareCommentLimitCountOptions: coursewareCommentLimitCountOptions,
      coursewareCommentTypeOptions: coursewareCommentTypeOptions,
      memberLearningProcessListTableOption: memberLearningProcessListTableOption,
      learningProcessTableData: [],
      coursewarePostTableData: [],
      tableLoading: false,
      coursewarePostTableLoading: false,
      learningStatusEnum: learningStatusEnum,
      search: {
        current: 1,
        size: 10,
        sortField: "",
        sortPolicy: "",
        searchValue: "",
        department: '',
        unionId: '',
        learningStatus: '',
        organizationalUnitName: "",
      },
      coursewarePostSearch: {
        current: 1,
        size: 10,
        postedByName: "",
        searchTime: [],
        sortField: "",
        sortPolicy: "",
        banComment: "",
        isBanned: "",
        keywords: "",
      },
      page: {
        total: 0,
        currentPage: 1,
        pageSize: 10,
      },
      coursewarePostPage: {
        total: 0,
        currentPage: 1,
        pageSize: 10,
      },
      departmentOptions: [],
      learningStatusOptions : learningStatusOptions,
      learningProcessExportName: '导出课时学习进度记录',
      learningProcessExportLoading: false,
      banDialogVisible: false,
      banDialogComment: "",
      banDialogIsSendWx: false,
      banDialogSendWxMessage: "",
      banDialogRow: 0,
      coursewarePostTableOption: coursewarePostTableOption,
      bannedCoursewarePostOptions: [
        { label: '是', value: 1 },
        { label: '否', value: 0 },
      ],
      coursewareDialogVisible: false,
      coursewareForm: {},
    }
  },
  watch: {
    $route() {
      this.id = this.$route.params.id;
      this.courseCoursewareId = this.$route.params.id;
      this.loadDepartmentOptions();
    },
  },
  async mounted() {
    this.id = this.$route.params.id;
    this.courseCoursewareId = this.$route.params.id;
    this.loadDepartmentOptions();
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      if (from.path.includes('/course-courseware-post')) {
        vm.activeName = 'courseCoursewarePost';
      }
    });
  },
  async created () {
    this.id = this.$route.params.id;
    await this.getDetail();
    this.handelMemberLearningProcessListTableOption();
  },
  computed: {
    startTime: function () {
      if (this.coursewarePostSearch.searchTime && this.coursewarePostSearch.searchTime.length > 0) {
        return this.coursewarePostSearch.searchTime[0]
      } else {
        return null
      }
    },
    endTime: function () {
      if (this.coursewarePostSearch.searchTime && this.coursewarePostSearch.searchTime.length > 1) {
        return this.coursewarePostSearch.searchTime[1]
      } else {
        return null
      }
    }
  },
  methods:{
    formatTime,
    handelMemberLearningProcessListTableOption() {
      this.memberLearningProcessListTableOption = {
        ...this.memberLearningProcessListTableOption,
        column: this.memberLearningProcessListTableOption.column.map((col) => {
          if ([coursewareSelectEnums.COMMENT.code, coursewareSelectEnums.CHECKIN.code].includes(this.detail.type)) {
              if (['learningTimeH', 'learningEndTime'].includes(col.prop)) {
                  return { ...col, hide: true };
              }
              
              const labelMap = {
                  [coursewareSelectEnums.COMMENT.code]: '留言发布时间',
                  [coursewareSelectEnums.CHECKIN.code]: '确认打卡时间'
              };
              
              if (col.label === '用户开始时间') {
                  return { ...col, label: labelMap[this.detail.type] };
              }
          }
          return col;
        }),
      };
    },
    async getDetail() {
      await getCourseCoursewareById(this.id).then(res => {
        this.detail = res.data.data;
      }).catch(error => {
        this.$message({
          message: '获取课时详情失败',
          type: 'error',
        });
      })
      this.getLearningProcessList(this)
      this.getCoursewarePostList()
    },
    getType(type) {
      for (let key in this.coursewareSelectEnums) {
        if (this.coursewareSelectEnums[key].code === type) {
          return this.coursewareSelectEnums[key].label;
        }
      }
      return '';
    },
    viewVideo(url) {
      window.open(url);
    },
    onTabShow(tab) {
      switch (tab.name) {
        case 'courseCoursewareDetail':
        case 'learningProcess':
          this.getLearningProcessList(this);
          break;
        case 'courseCoursewarefavorite':
          this.initCourseCoursewareFavorite();
          break;
        case 'courseCoursewareComment':
          this.initCourseCoursewareComment();
          break;
        case 'courseCoursewarePost':
          this.getCoursewarePostList();
          break;
      }
    },
    handleView(id) {
      this.$router.push(`/app/course/courseware/${id}`);
    },
    getCommentType(value) {
      return this.coursewareCommentTypeOptions.find(item => item.value === value ).label;
    },
    getCommentLimitCount(value) {
      return this.coursewareCommentLimitCountOptions.find(item => item.value === value ).label;
    },
    handleUp(row, index) {
      let _this = this;
      this.$confirm('是否确认上架内容为"' + row.content + '"'+ '的评论?', '警告', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        updateCommentStatus(row.id, null).then(response => {
          if (response.data.data) {
            _this.$message({
              message: '上架成功',
              type: 'success'
            })
            _this.initCourseCoursewareComment();
          }
        }).catch(error => {
          _this.$message({
            message: '上架失败',
            type: 'error'
          })
        });
      });
    },
    handleDown(row, index) {
      this.banDialogRow = row;
      this.banDialogComment = "";
      this.banDialogIsSendWx = false;
      this.banDialogSendWxMessage = this.formatDownMessage(row);
      this.banDialogVisible = true;
    },
    formatDownMessage(row) {
      const courseName = row.courseName;
      const course = courseName.length > 10 ? (courseName.substr(0, 10) + "...") : courseName;
      const coursewareName = row.courseCoursewareName;
      const courseware = coursewareName === '--' ? undefined : (coursewareName.length > 10 ? (coursewareName.substr(0, 10) + "...") : coursewareName);
      const commentContent = row.content;
      const commnet = commentContent.length > 10 ? (commentContent.substr(0, 10) + "...") : commentContent;
      return `您在 课程【${course}】${!courseware ? '' : `课时【${courseware}】`}中发布的评论【${commnet}】未能通过审核，请重新发布内容`
    },
    handleDownSubmit() {
      if (!this.banDialogComment) {
        this.$message({
          showClose: true,
          message: '下架原因不能为空',
          type: 'error'
        });
        return;
      }
      let courseCommentBanDTO= {
        banComment: this.banDialogComment,
        isSendWxMessage: this.banDialogIsSendWx,
        wxMessage: this.banDialogSendWxMessage,
      }
      updateCommentStatus(this.banDialogRow.id, courseCommentBanDTO).then(response => {
        if (response.data.data) {
          this.$message({
            message: '下架成功',
            type: 'success'
          })
          this.banDialogVisible = false;
          this.initCourseCoursewareComment();
        }
      })
      .catch(error => {
        this.$message({
          message: '下架失败',
          type: 'error'
        })
      });
    },
    goBack() {
      this.$router.push({ 
        path: `/app/course/detail/${this.detail.courseId}`, 
        query: { tab: 'CourseChapter' } 
      });
    },
    loadDepartmentOptions() {
      fetchDepartmentOptions().then(response => {
        if (response.data && response.data.code === 0 && response.data.data) {
          this.departmentOptions = response.data.data;
        }
      });
    },
    searchChange() {
      this.learningProcessTableData = [];
      this.getLearningProcessList(this);
    },
    sizeChange(val) {
      this.page.pageSize = val;
      this.search.size = val;
      this.learningProcessTableData = [];
      this.getLearningProcessList(this);
    },
    currentChange(val) {
      this.page.currentPage = val;
      this.search.current = val;
      this.learningProcessTableData = [];
      this.getLearningProcessList(this);
    },
    sortChange(val) {
      if (val.prop == "createTime") {
        this.search.sortField = "inserted_time";
      } else {
        this.search.sortField = "";
      }
      // 检查排序方式
      if (val.order == 'ascending') {
        this.search.sortPolicy = "asc";
      } else if (val.order == 'descending') {
        this.search.sortPolicy = "desc";
      } else {
        this.search.sortPolicy = "";
      }
      this.learningProcessTableData = [];
      this.getLearningProcessList(this);
    },
    searchReset() {
      this.search.searchValue = "";
      this.search.department = "";
      this.search.unionId = '';
      this.search.learningStatus = '';
      this.search.organizationalUnitName = '';
      this.learningProcessTableData = [];
      this.getLearningProcessList(this);
    },
    handleLearningProcessExport() {
      if (this.search.current === 1 && this.learningProcessTableData.length === 0) {
        return this.$message({
          message: "导出失败，没有可导出的信息",
          type: "warning",
        })
      }
      exportLearningProcess(this.generateLearningProcessListSearchParams()).then(({data}) => {
        if (data.code === 0) {
          this.learningProcessExportLoading = true;
          this.learningProcessExportName = "导出中...";
          exporting(data.data, this.learningProcessExportCallback);
        } else {
          this.$message.error(data.msg);
        }
      })
    },
    learningProcessExportCallback(result) {
      this.learningProcessExportLoading = false;
      this.learningProcessExportName = "导出课时学习进度记录";
      if (result) {
        this.$message({
          showClose: true,
          message: '导出完成',
          type: 'success'
        });
      }
    },
    generateLearningProcessListSearchParams() {
      let params = {
        current: this.search.current,
        size: this.search.size,
        courseCoursewareId: this.id,
        courseCoursewareType: this.detail.type,
      }
      if (this.search.searchValue != "" && this.search.searchValue.trim() != "") {
        params.searchValue = this.search.searchValue;
      }
      if (this.search.department != "" && this.search.department.trim() != "") {
        params.department = this.search.department;
      }
      if (this.search.unionId != "" && this.search.unionId.trim() != "") {
        params.unionId = this.search.unionId;
      }
      if (this.search.organizationalUnitName != "" && this.search.organizationalUnitName.trim() != "") {
        params.organizationalUnitName = this.search.organizationalUnitName;
      }
      if (this.search.learningStatus) {
        params.learningStatus = this.search.learningStatus;
      }
      if (this.search.sortField != "" && this.search.sortField.trim() != "") {
        params.sortField = this.search.sortField;
      } else {
        params.sortField = "inserted_time";
        this.search.sortField = params.sortField;
      }
      if (this.search.sortPolicy != "" && this.search.sortPolicy.trim() != "") {
        params.sortPolicy = this.search.sortPolicy;
      } else {
        params.sortPolicy = "desc"
        this.search.sortPolicy = params.sortPolicy;
      }
      return params;
    },
    getLearningProcessList(vm) {
      let params = this.generateLearningProcessListSearchParams();
      this.tableLoading = true;
      fetchLearningProcessList(params).then(({data}) => {
        if (data.code === 0) {
          this.formatLearningProcessBaseDetail(vm, data.data.records);
          this.page.total = data.data.total;
          this.tableLoading= false;
        } else {
          this.$message.error(data.msg);
        }
      });
    },
    formatLearningProcessBaseDetail(vm, data) {
      let list = [];
      data.forEach((item) => {
        item.department = !item.department ? '' : item.department.substring(item.department.indexOf(' '));
        item.learningEndTime = !item.learningEndTime ? '--' : item.learningEndTime;
        list.push(item);
      });
      vm.learningProcessTableData = list;
    },
    handleCoursewarePostCurrentChange(val) {
      this.coursewarePostPage.currentPage = val;
      this.coursewarePostSearch.current = val;
      this.getCoursewarePostList();
    },
    handleCoursewarePostSizeChange(val) {
      this.coursewarePostPage.pageSize = val;
      this.coursewarePostSearch.size = val;
      this.getCoursewarePostList();
    },
    handleCoursewarePostSortChange(val) {
      if (val.prop == "commentCount") {
        this.coursewarePostSearch.sortField = "comment_count"
      } else if (val.prop == "likeCount") {
        this.coursewarePostSearch.sortField = "like_count"
      } else if (val.prop == "insertedTime"){
        this.coursewarePostSearch.sortField = "inserted_time"
      } else {
        this.coursewarePostSearch.sortField = ""
      }
      if (val.order == 'ascending') {
        this.coursewarePostSearch.sortPolicy = "asc"
      } else if (val.order == 'descending') {
        this.coursewarePostSearch.sortPolicy = "desc"
      } else {
        this.coursewarePostSearch.sortPolicy = ""
      }
      this.getCoursewarePostList()
    },
    coursewarePostSearchReset() {
      this.coursewarePostSearch.postedByName = "";
      this.coursewarePostSearch.searchTime = [];
      this.coursewarePostSearch.banComment = '';
      this.coursewarePostSearch.isBanned = "";
      this.coursewarePostSearch.keywords = "";
      this.coursewarePostSearchChange();
    },
    coursewarePostSearchChange() {
      this.initCoursewarePostPage();
      this.getCoursewarePostList();
    },
    getCoursewarePostList() {
      let params = this.getCoursewarePostParams();
      this.coursewarePostTableLoading = true;
      fetchCoursewarePostList(params).then(({data}) => {
        if (data.code === 0) {
          this.coursewarePostTableData = this.formatCoursewarePostData(data.data.records);
          this.coursewarePostPage.total = data.data.total;
          this.coursewarePostTableLoading= false;
        } else {
          this.$message.error(data.msg);
        }
      });
    },
    formatCoursewarePostData (records) {
      if (records && records.length > 0) {
        records.forEach(function(record, index) {
          if (record.postedBy) {
            record.postedByUnionId = record.postedBy.unionId;
            record.postedByName = record.postedBy.name ? record.postedBy.name : "--";
          }
          if(!record.title && !record.titleEn) {
            record.title = "--"
          }
          if (!record.commentCount) {
            record.commentCount = 0
          }
          if (!record.likeCount) {
            record.likeCount = 0
          }
        })
      }
      return records;
    },
    getCoursewarePostParams() {
      let params = {
        current: this.coursewarePostSearch.current,
        size: this.coursewarePostSearch.size,
        courseCoursewareId: this.id,
      }
      if (this.coursewarePostSearch.keywords != "" && this.coursewarePostSearch.keywords.trim() != "")
        params.keywords = this.coursewarePostSearch.keywords;
      if (this.coursewarePostSearch.postedByName != "" && this.coursewarePostSearch.postedByName.trim() != "")
        params.postedByName = this.coursewarePostSearch.postedByName;
      if (this.coursewarePostSearch.isBanned != null)
        params.isBanned = this.coursewarePostSearch.isBanned;
      if (this.startTime && this.endTime) {
        params.startTime = this.startTime;
        let t = new Date(this.endTime);
        t.setDate(t.getDate()+1);
        params.endTime = t.getFullYear()+'-'+(t.getMonth()+1)+'-'+t.getDate();
      } else {
        params.startTime = null;
        params.endTime = null;
      }
      if (this.coursewarePostSearch.banComment !="" && this.coursewarePostSearch.banComment.trim() != "")
        params.banComment = this.coursewarePostSearch.banComment;
      if (this.coursewarePostSearch.sortField != "" && this.coursewarePostSearch.sortField.trim() != "")
        params.sortField = this.coursewarePostSearch.sortField;
      else
        params.sortField = "inserted_time";
      if (this.coursewarePostSearch.sortPolicy != "" && this.coursewarePostSearch.sortPolicy.trim() != "")
        params.sortPolicy = this.coursewarePostSearch.sortPolicy;
      else
        params.sortPolicy="desc";
      return params;
    },
    initCoursewarePostPage() {
      this.coursewarePostPage.currentPage = 1;
      this.coursewarePostPage.pageSize = this.coursewarePostSearch.size;
      this.coursewarePostSearch.current = 1;
    },
    getCoursewarePostDTO(row, inputIsBanned) {
      let coursewarePostDTO = {
        memberId: row.postedBy.id,
        postId: row.id,
        isBanned: inputIsBanned,
      }
      return coursewarePostDTO
    },
    handleCoursewarePostUp(row, index) {
      let coursewarePostDTO = this.getCoursewarePostDTO(row, 0)
      let _this = this
      this.$confirm('是否确认上架该标题为"' + row.title + '"'+ '的课时留言帖子?', '警告', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        return updateCoursewarePostBanStatus(coursewarePostDTO);
      }).then((response) => {
        if (response.data.code === 0) {
          this.getCoursewarePostList()
          _this.$message({
            showClose: true,
            message: '上架成功',
            type: 'success'
          })
        } else {
          this.$message({
            type: 'error',
            message: response.data.msg
          });
        }

      }).catch(function () {
      })
    },
    handleCoursewarePostDown(row, index) {
      this.banDialogRow = row;
      this.banDialogComment = "";
      this.banDialogIsSendWx = false;
      this.banDialogSendWxMessage = "你发布的图片或视频未能通过系统审核，请重新审核发布内容";
      this.banDialogVisible = true;
    },
    handleCoursewarePostDownSubmit() {
      if (!this.banDialogComment) {
        this.$message({
          showClose: true,
          message: '下架原因不能为空',
          type: 'error'
        });
        return;
      }

      if (this.banDialogIsSendWx && !this.banDialogSendWxMessage) {
        this.$message({
          showClose: true,
          message: '发送消息不能为空',
          type: 'error'
        });
        return;
      }

      let coursewarePostDTO = this.getCoursewarePostDTO(this.banDialogRow, 1);
      coursewarePostDTO.banComment = this.banDialogComment;
      coursewarePostDTO.isSendWxMessage = this.banDialogIsSendWx;
      coursewarePostDTO.wxMessage = this.banDialogSendWxMessage;
      updateCoursewarePostBanStatus(coursewarePostDTO)
        .then(response => {
          if (response.data.code === 0) {
            this.getCoursewarePostList();
            this.$message({
              showClose: true,
              type: 'success',
              message: '下架成功'
            });
          } else {
            this.$message({
              type: 'error',
              message: response.data.msg
            });
          }
        })
        .catch(function () {})
        .finally(() => {
          this.banDialogVisible = false;
        });
    },
    handleCoursewarePostView(row) {
      this.$router.push({ path: `/app/course/course-courseware-post/${row.id}`, query: { id: this.id } });
    },
    handleEditCourseCourseware() {
      this.formatDetail(this.detail)
      this.coursewareDialogVisible = true;
    },
    formatDetail(detail) {
      this.coursewareForm = {
        id: detail.id,
        courseId: detail.courseId,
        courseChapterId: detail.courseChapterId,
        coursewareId: detail.coursewareId,
        coursewareName: detail.coursewareName,
        name: detail.courseCoursewareName,
        nameEn: detail.courseCoursewareNameEn,
        description: detail.courseCoursewareDescription,
        descriptionEn: detail.courseCoursewareDescriptionEn,
        startTime: detail.courseCoursewareStartTime,
        rewardValue: detail.courseCoursewareRewardValue,
        commentActive: detail.courseCoursewareCommentActive,
        commentType: detail.courseCoursewareCommentType,
        commentLimitCount: detail.courseCoursewareCommentLimitCount,
        insertedTime: detail.courseCoursewareInsertedTime,
        creator: detail.courseCoursewareCreator,
      }
    },
    closeCoursewareDialog() {
      this.coursewareDialogVisible = false;
      this.getDetail();
    }
  }
}
</script>

<style lang="scss" scoped>
.course-courseware-detail {
  &-item {
    font-size: 16px;
    margin: 10px 0;
  }
  &-description {
    margin-top: -16px;
    max-width: 500px;
    word-wrap: break-word;
    word-break: break-word;
    white-space: normal;
  }
}
::v-deep img{
  max-width:100%;
}
.course-courseware-content-video {
  display: flex;
  width: fit-content;
  cursor: pointer;
  img {
    width: 356px;
    height: 200px;
    object-fit: cover;
    max-width: 100%;
  }
}
.courseware-url, .courseware-name {
  cursor: pointer;
  color: #409EFF;
}
.back-button {
  position: fixed;
  top: 77px;
  font-size: 16px;
  color: #3B3B3B;
  cursor: pointer;
}
.course-learning-process-list {
  &-filter {
    margin: 0 10px;
    /deep/ .el-input__inner {
      font-size: 14px;
    }
    &-value {
      width: 96% !important;
    }
    &-search {
      float: right;
      margin-right: 8px;
    }
    &-reset {
      float: right;
      margin-right: 10px;
      border-color: #5383f3;
      color: #5383f3;
    }
  }
}
.courseware-post-list {
  &-filter {
    margin: 0 10px;
    /deep/ .el-input__inner {
      font-size: 14px;
    }
    &-value {
      width: 96% !important;
    }
    &-search {
      float: right;
      margin-right: 8px;
    }
    &-reset {
      float: right;
      margin-right: 10px;
      border-color: #5383f3;
      color: #5383f3;
    }
    &-date {
      width: 96% !important;
    }
  }
  &-container {
    padding-top: 0px;
    &-button {
      color: #409EFF;
      font-size: 14px;
      text-align: center;
      font-weight: 500;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      width: 170px;
      text-align: left;
    }
  }
}
.hide-redundant-post-images {
  display: none;
}
.title {
  display: flex;
  align-items: center;
  .courseware-post-cover-image {
    display: flex;
    width: fit-content;
    margin-right: 12px;
    cursor: pointer;
    img {
      width: 40px;
      height: 40px;
      object-fit: cover;
      max-width: 100%;
    }
  }
}
.operation {
  text-align: right
}
.down-dialog-item-label {
  display: inline-block;
  margin: 10px 0;
}
</style>
